import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { authAPI } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [me, setMe] = useState(null);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      if (!token) {
        if (mounted) {
          setMe(null);
          setChecking(false);
        }
        return;
      }

      try {
        const resp = await authAPI.me();
        if (mounted) {
          setMe(resp.data);
        }
      } catch (e) {
        if (mounted) {
          setMe(null);
        }
      } finally {
        if (mounted) {
          setChecking(false);
        }
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, [token]);

  if (!token) {
    // 如果没有token，重定向到登录页
    return <Navigate to="/login" replace />;
  }

  if (checking) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  const isAdmin = !!me?.is_admin;
  const roleName = String(me?.role_name || '').toUpperCase();
  const path = location?.pathname || '/';

  if (!isAdmin) {
    if (roleName === 'CHECK_USER') {
      if (path === '/') {
        return <Navigate to="/topic-records" replace />;
      }
      const allowed = new Set(['/topic-records', '/trade-records']);
      if (!allowed.has(path)) {
        return <Navigate to="/topic-records" replace />;
      }
    } else {
      // 默认普通用户（含 LOGIN_USER 或未配置角色）
      if (path !== '/welcome') {
        return <Navigate to="/welcome" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;
